import type { ComponentProps } from 'react'
import { Button } from '@/components/ui/button'

export function AddChip({ children, ...props }: ComponentProps<typeof Button>) {
  return (
    <Button
      type="button"
      variant="outline"
      size="inline"
      className="h-8 border-dashed px-2 text-caption font-normal text-muted-foreground hover:text-foreground"
      {...props}
    >
      + {children}
    </Button>
  )
}
